module.exports = __webpack_public_path__ + "img/joyas.f8cba2c5.jpg";